export default __webpack_public_path__ + "static/media/BCBA.11b9712e.svg";